import { useEffect } from 'react';
import { rage, useObservable } from '~/rage';
import { Layouts } from '~/shared';
import { HomeMenu } from '../../components/HomeMenu';
import { SellMenu } from '../../components/SellMenu';
import {
	setActiveMenu,
	setHouseData,
	useLayoutDispatch,
	useLayoutSelector,
} from '../../redux';
import { StyledContainer, StyledWrapper } from './HomeBuying.styled';

const HomeBuying: React.FC = () => {
	const dispatch = useLayoutDispatch();
	const activeMenu = useLayoutSelector((state) => state.homeBuying.activeMenu);
	const houseData = useObservable(rage.houses.getCurrentHouse());

	useEffect(() => {
		dispatch(setHouseData(houseData));

		// Когда выходим из меню, всегда возвращаемся на главный экран
		if (!houseData.id) {
			dispatch(setActiveMenu('home'));
		}
	}, [houseData]);

	return (
		<StyledWrapper className={Layouts.HomeBuying}>
			<StyledContainer>
				{activeMenu === 'home' && <HomeMenu />}
				{activeMenu === 'sell' && <SellMenu />}
			</StyledContainer>
		</StyledWrapper>
	);
};
export { HomeBuying };
